import * as Sf from '../../utils/services/salesforce';
import * as Query from '../../queries';

export const getAllSquads = () => {
  return new Promise((resolve, reject) => {
    const query = Query.getAllSquads();
    Sf.runQuery(query).then(
      res => {
        const squads = res.records;
        const squadsNames = squads.map(squad => {
          return squad.Name;
        });
        return resolve({ squads, squadsNames });
      },
      err => console.error(err)
    );
  });
};

export const getAllMembers = () => Sf.runGetQueryInBatchesAndCompileData(Query.getSquadsMembers);

export const getAllUsers = async () => {
  const query = Query.getCTCByName('Perfis Virada');

  const ctcResponse = await Sf.runQuery(query);

  const joinedProfiles = `'${JSON.parse(ctcResponse.records[0].Structure__c).profiles.join(
    "', '"
  )}'`;

  const fullQuery = Query.getAllUsersAll(joinedProfiles);

  const allRecords = [];
  let nextUrl;
  let resp;

  const params = { q: query };

  do {
    const response = await Sf.runQueryAll(fullQuery, nextUrl, {
      params
    });

    resp = response;

    allRecords.push(...response.records);

    nextUrl = response.nextRecordsUrl;
  } while (!resp.done);

  // intencional
  console.log('End get all users:', allRecords.length);

  return allRecords;
};

export const getAllProfiles = () => {
  return new Promise((resolve, reject) => {
    const query = Query.getAllProfiles();
    Sf.runQuery(query).then(
      res => {
        const allProfiles = res.records;
        return resolve(allProfiles);
      },
      err => console.error(err)
    );
  });
};

export const getAllRoles = () => {
  return new Promise((resolve, reject) => {
    const offsetToUse = 2000;
    const numberOfQueries = 2;
    const promises = [];

    for (let i = 0; i < numberOfQueries; i++) {
      const currentQuery = Query.getAllRoles(offsetToUse, offsetToUse * i);
      promises.push(Sf.runQuery(currentQuery));
    }

    Promise.all(promises).then(
      values => {
        let allRoles = [];

        values.map(currentValues => {
          allRoles.push(...currentValues.records);
          return currentValues;
        });

        return resolve(allRoles);
      },
      err => console.error(err)
    );
  });
};

export const getAllChannels = () => {
  return new Promise((resolve, reject) => {
    const query = Query.getAllChannels();
    Sf.runQuery(query).then(
      res => {
        const allChannels = res.records;
        return resolve(allChannels);
      },
      err => console.error(err)
    );
  });
};
